import React, { useEffect } from 'react'
import LayoutActions from '../redux/actions/LayoutActions'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import UserRoute from '../routers/UserRoute'
import { connect } from 'react-redux'
import { Box } from '@mui/material'
import { layoutPageComponents as components } from './components/layoutPageComponents'

const stripBase = (path) => {
    const base = window.__ADMIN_STOCK_BASENAME__ || '';
    if (!base) return path;
    if (path === base || path === `${base}/`) return '/';
    if (path.startsWith(`${base}/`)) return path.slice(base.length) || '/';
    return path;
};

function DeductionRoutingLayout({
    setPathCheck,
    permission,
    reformat,
    selectedRestaurant,
    location
}) {
    const access = reformat(permission.subPage)
        .sort((a, b) => {
            // Check if either 'order' is null
            if (a.order === null && b.order === null) {
                return 0; // Keep the order unchanged if both are null
            } else if (a.order === null) {
                return 1; // Place 'a' (null) after 'b' (non-null)
            } else if (b.order === null) {
                return -1; // Place 'b' (null) after 'a' (non-null)
            }
            // Sort non-null 'order' values normally
            return a.order - b.order;
        });
    useEffect(() => {
        const currentPath = location?.pathname || stripBase(window.location.pathname);

        // Keep top navigation in sync with the active deduction-routing child page.
        const matchedChildRoute = access.find((page) => page.route === currentPath)?.route;
        if (matchedChildRoute) {
            setPathCheck(matchedChildRoute);
            return;
        }

        // Fallback for nested paths under a child route.
        const parentChildRoute = access.find((page) => currentPath.startsWith(`${page.route}/`))?.route;
        if (parentChildRoute) {
            setPathCheck(parentChildRoute);
            return;
        }

        // Fallback to layout route when no child route matches.
        setPathCheck(permission.route);
    }, [permission.route, setPathCheck, location?.pathname, access])
    
    return (
        <div>
            <Box>
                <Switch>
                    <Route exact path="/stock-app/deduction-routing" render={() => <Redirect to={access[0]?.route} />} />
                    {access.map((permission2, i) =>
                        <UserRoute key={i} exact path={permission2.route} component={components[permission2.key]} permission={permission2} />
                    )}
                    <Redirect from="*" to="/not-found" />
                </Switch>
            </Box>
        </div>
    )
}
const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
    setPathCheck: (data) => dispatch(LayoutActions.setPathCheck(data)),
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeductionRoutingLayout))